// extracted by mini-css-extract-plugin
export default {"LoadingPage":"Loading_LoadingPage__XXFjI","Loading":"Loading_Loading__zmz0L"};